// import
import AdminDashboard from "views/Dashboard/AdminDashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Profile from "views/Dashboard/Profile.js";
import Customers from "views/Dashboard/Customers.js";
import Personnels from "views/Dashboard/Personnels";
import Account from "views/Dashboard/Account.js";
import Inventory from "views/Dashboard/Inventory.js";
import InventoryReports from "views/Dashboard/InventoryReports";
import Tools from "views/Dashboard/Tools.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  HelpIcon,
  SettingsIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  {
    path: "/inventory",
    name: "Inventory",
    rtlName: "لوحة القيادة",
    icon: <SupportIcon color="inherit" />,
    component: Inventory,
    layout: "/auditor",
  },
  {
    path: "/tools",
    name: "Tools",
    rtlName: "لوحة القيادة",
    icon: <HelpIcon color="inherit" />,
    component: Tools,
    layout: "/auditor",
  },
  {
    path: "/reports",
    name: "Reports",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: InventoryReports,
    layout: "/auditor",
  },
  {
    path: "/customers",
    name: "Customers",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: Customers,
    layout: "/auditor",
  },
  {
    path: "/account",
    name: "Account",
    rtlName: "لوحة القيادة",
    icon: <SettingsIcon color="inherit" />,
    secondaryNavbar: true,
    component: Account,
    layout: "/auditor",
  },
];
export default dashRoutes;
